"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _TaskItem = _interopRequireDefault(require("../components/TaskItem"));
var _PrizeItem = _interopRequireDefault(require("../components/PrizeItem"));
var _lotteryAssistant = require("@/api/lotteryAssistant");
var _adv = require("@/api/ads/adv");
var _applet = require("@/api/operation/applet");
var _enums = require("../enums");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var chineseNumberMaps = {
  1: '一',
  2: '二',
  3: '三',
  4: '四',
  5: '五',
  6: '六',
  7: '七',
  8: '八',
  9: '九'
};
var operateMaps = {
  add: '新增活动',
  edit: '编辑活动',
  copy: '复制活动',
  detail: '活动详情'
};
var _default = exports.default = {
  name: 'LotteryAssistantCreatActivity',
  components: {
    Tinymce: _index.default,
    TaskItem: _TaskItem.default,
    PrizeItem: _PrizeItem.default
  },
  data: function data() {
    var _this2 = this;
    var disabledDate = function disabledDate(time) {
      if (_this2.detail.drawStartTime) {
        return time.getTime() < new Date(_this2.detail.drawStartTime).getTime();
      }
      return time.getTime() < Date.now() - 8.64e7;
    };
    var ruleValidate = JSON.parse(JSON.stringify(_enums.formRules));
    ruleValidate.drawTime[0].validator = function (rule, value, callback) {
      if (_this2.formData.activityLimitTime === 1) {
        if (!value || !value.length) {
          return callback(new Error('请选择活动时间'));
        }
      }
      callback();
    };
    return {
      backUrl: '/marketing/lottery-assistant/activity',
      tempRoute: {},
      operate: 'add',
      operateMaps: operateMaps,
      id: '',
      grid: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
      headTab: [{
        tit: '基础设置',
        name: '1'
      }, {
        tit: '抽奖设置',
        name: '2'
      }, {
        tit: '奖项设置',
        name: '3'
      }],
      currentTab: '1',
      typeOptions: _enums.typeOptions,
      styleOptions: _enums.defaultTypeDataMap[2].__extra__.styleOptions,
      joinTypeOptions: _enums.defaultTypeDataMap[2].__extra__.joinTypeOptions,
      pickerOptions: {
        // 时间有效校验
        disabledDate: disabledDate
      },
      appList: [],
      replyList: [],
      qrcodeList: [],
      advList: [],
      loading: false,
      detail: {
        // drawStartTime: '2025-03-20 00:00:00'
      },
      isReplyAll: false,
      formData: JSON.parse(JSON.stringify(_enums.defaultFormData)),
      ruleValidate: ruleValidate,
      loadingBtn: false,
      taskTab: '0',
      prizeTab: '0'
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['mediaDomain'])), {}, {
    isDisabled: function isDisabled() {
      return this.operate === 'detail';
    },
    isEdit: function isEdit() {
      return this.operate === 'edit';
    },
    isCopy: function isCopy() {
      return this.operate === 'copy';
    },
    maxPrizeLength: function maxPrizeLength() {
      var activityStyle = this.formData.activityStyle;
      if (activityStyle === 4) {
        return 8;
      } else if (activityStyle === 5) {
        return 10;
      } else if (activityStyle === 6) {
        return 3;
      } else if (activityStyle === 7) {
        return 3;
      }
      return 12;
    },
    prizeRemovable: function prizeRemovable() {
      return ![4, 5].includes(this.formData.activityStyle);
    },
    prizeWinProbabilityTotal: function prizeWinProbabilityTotal() {
      var prizes = this.formData.prizes;
      var length = prizes.length;
      var idx = prizes.findIndex(function (item, index) {
        return index === length - 1;
      });
      var total = 0;
      prizes.forEach(function (item, index) {
        if (index !== idx) {
          total += (item.winProbability || 0) * 100;
        }
      });
      return total / 100;
    }
  }),
  watch: {
    'formData.replyIds': {
      handler: function handler(v) {
        this.checkReplyAll();
      },
      deep: true,
      immediate: true
    }
  },
  created: function created() {
    this.tempRoute = Object.assign({}, this.$route);
    this.operate = this.$route.params.operate;
    this.id = this.$route.params.id;
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (this.mediaDomain) {
              _context.next = 3;
              break;
            }
            _context.next = 3;
            return this.$store.dispatch('settings/getMediaDomain');
          case 3:
            if (this.id && this.id !== '0') {
              this.getActivityInfo(this.id);
            } else {
              this.initActivity();
              this.getReplyList();
            }
            // 获取客服二维码下拉数据
            this.getQrcodeList();
            // 获取广告下拉数据
            this.getAdvList();
            this.getAppList();
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapMutations)('menu', ['closeTag'])), {}, {
    getActivityInfo: function getActivityInfo(id) {
      var _this3 = this;
      this.loading = true;
      (0, _lotteryAssistant.activityDetailApi)(id).then(function (data) {
        _this3.initData(data);
        _this3.loading = false;
      }).catch(function (res) {
        _this3.loading = false;
      });
    },
    initData: function initData(data) {
      data.drawTime = [data.drawStartTime, data.drawEndTime];
      data.replyIds = (data.replyId || '').split(',').filter(function (v) {
        return v;
      });
      this.detail = data;
      for (var key in data) {
        if (this.formData.hasOwnProperty(key)) {
          this.formData[key] = data[key];
        }
      }
      var _ref = _enums.defaultTypeDataMap[data.activityType] || {},
        _ref$__extra__ = _ref.__extra__,
        __extra__ = _ref$__extra__ === void 0 ? {} : _ref$__extra__;
      for (var extraKey in __extra__) {
        if (typeof this[extraKey] !== 'undefined') {
          this[extraKey] = __extra__[extraKey];
        }
      }
      if (this.formData.activityType === 2) {
        // 定时抽红包
        this.getReplyList();
        if (!this.formData.assistTasks || !this.formData.assistTasks.length) {
          this.initTimedTasks();
        }
      }
    },
    getAppList: function getAppList() {
      var _this4 = this;
      var params = {
        page: 1,
        limit: 1000
      };
      (0, _applet.appletListApi)(params).then(function (data) {
        _this4.appList = (data.list || []).map(function (item) {
          item.label = item.appName;
          item.value = item.id;
          return item;
        });
      });
    },
    getReplyList: function getReplyList() {
      var _this5 = this;
      // 获取往期锦鲤列表接口
      (0, _lotteryAssistant.getReplyListApi)().then(function (data) {
        _this5.replyList = data || [];
        if (_this5.operate === 'add') {
          _this5.formData.replyIds = _this5.replyList.map(function (item) {
            return item.id;
          });
        }
        _this5.checkReplyAll();
      });
    },
    // 获取客服二维码下拉数据
    getQrcodeList: function getQrcodeList() {
      var _this$$api,
        _this6 = this;
      if (typeof ((_this$$api = this.$api) === null || _this$$api === void 0 ? void 0 : _this$$api.getEnableQrcodeListApi) === 'function') {
        this.$api.getEnableQrcodeListApi().then(function (res) {
          _this6.qrcodeList = res || [];
        });
      } else {
        // 兼容直接引入
        Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/api/lotteryAssistant'));
        }).then(function (api) {
          api.getEnableQrcodeListApi().then(function (res) {
            _this6.qrcodeList = res || [];
          });
        });
      }
    },
    // 获取广告下拉数据
    getAdvList: function getAdvList() {
      var _this7 = this;
      (0, _adv.getEnableAdvListApi)({
        adType: 4
      }).then(function (res) {
        _this7.advList = res || [];
      });
    },
    checkReplyAll: function checkReplyAll() {
      this.isReplyAll = this.formData.replyIds.length === this.replyList.length;
    },
    changeType: function changeType() {
      var activityType = this.formData.activityType;
      var formData = _enums.defaultTypeDataMap[activityType] || {};
      for (var formDataKey in formData) {
        var val = formData[formDataKey];
        if (formDataKey === '__extra__') {
          for (var optK in val) {
            this[optK] = val[optK];
          }
        } else {
          if (formDataKey === 'activityBackPic') {
            val = this.mediaDomain + val;
          }
          this.formData[formDataKey] = val;
        }
      }
      this.taskTab = '0';
      this.prizeTab = '0';
      if (activityType === 2) {
        this.initStyleTimedPrizes();
        this.initTimedTasks();
      } else {
        this.initStyleGridPrizes();
      }
    },
    changeStyle: function changeStyle() {
      var _this$formData = this.formData,
        activityStyle = _this$formData.activityStyle,
        prizes = _this$formData.prizes;
      var formData = _enums.defaultStyleDataMap[activityStyle] || {};
      for (var formDataKey in formData) {
        var val = formData[formDataKey];
        if (formDataKey === 'activityBackPic') {
          val = this.mediaDomain + val;
        }
        this.formData[formDataKey] = val;
      }
      if ([4, 5].includes(activityStyle)) {
        if (prizes.length !== this.maxPrizeLength) {
          this.initStyleGridPrizes();
          this.prizeTab = '0';
        }
        if (activityStyle === 5) {
          this.formData.prizes.forEach(function (item) {
            if (item.prizeType === 2) {
              item.prizeType = 3;
            }
          });
        }
      }
    },
    initActivity: function initActivity() {
      var _this$formData2 = this.formData,
        activityType = _this$formData2.activityType,
        activityBackPic = _this$formData2.activityBackPic;
      this.formData.activityBackPic = this.mediaDomain + activityBackPic;
      if (activityType === 1) {
        // 九宫格抽奖
        this.initStyleGridPrizes();
      } else if (activityType === 2) {
        this.initStyleTimedPrizes();
        this.initTimedTasks();
      }
    },
    initStyleGridPrizes: function initStyleGridPrizes() {
      var list = [];
      var length = this.maxPrizeLength;
      for (var i = 0; i < length; i++) {
        var prize = JSON.parse(JSON.stringify(_enums.prizeItem));
        prize.prizePic = this.mediaDomain + _enums.prizeItemPicMap[0];
        prize.awardName = "".concat(chineseNumberMaps[i + 1], "\u7B49\u5956");
        if (i === length - 1) {
          prize = _objectSpread(_objectSpread({}, prize), {}, {
            awardName: '谢谢参与',
            prizeName: '谢谢参与',
            prizeType: 99,
            winProbability: 100,
            redemptionRule: '',
            prizePic: this.mediaDomain + _enums.prizeItemPicMap[99]
          });
        }
        list.push(prize);
      }
      this.formData.prizes = list;
    },
    initStyleTimedPrizes: function initStyleTimedPrizes() {
      var prize = JSON.parse(JSON.stringify(_enums.prizeItem));
      prize.prizePic = this.mediaDomain + _enums.prizeItemPicMap[0];
      prize.awardName = "".concat(chineseNumberMaps[1], "\u7B49\u5956");
      this.formData.prizes = [prize];
    },
    initTimedTasks: function initTimedTasks() {
      var task = JSON.parse(JSON.stringify(_enums.taskItem));
      task.taskMode = 3;
      this.formData.assistTasks = [task];
    },
    winFlagChange: function winFlagChange(_ref2) {
      var index = _ref2.index;
      this.formData.prizes.forEach(function (item, idx) {
        if (idx !== index) {
          item.winFlag = 0;
        }
      });
    },
    removeTaskItem: function removeTaskItem(targetName) {
      var index = +targetName;
      if (this.taskTab !== '0' && this.taskTab >= index) {
        this.taskTab = '' + (+this.taskTab - 1);
      }
      this.formData.assistTasks.splice(index, 1);
    },
    addTaskItem: function addTaskItem() {
      var assistTasks = this.formData.assistTasks;
      var task = JSON.parse(JSON.stringify(_enums.taskItem));
      assistTasks.push(task);
    },
    removePrizeItem: function removePrizeItem(targetName) {
      var index = +targetName;
      if (this.prizeTab !== '0' && this.prizeTab >= index) {
        this.prizeTab = '' + (+this.prizeTab - 1);
      }
      this.formData.prizes.splice(index, 1);
      if (this.formData.activityType === 2) {
        this.formData.prizes.forEach(function (item, i) {
          item.awardName = item.prizeType === 99 ? '谢谢参与' : "".concat(chineseNumberMaps[i + 1], "\u7B49\u5956");
        });
      }
    },
    addPrizeItem: function addPrizeItem() {
      var prizes = this.formData.prizes;
      var prizeLen = prizes.length;
      if (prizeLen >= this.maxPrizeLength) {
        return;
      }
      // 寻找谢谢参与的奖项下标
      var index = prizes.findIndex(function (item) {
        return item.prizeType === 99;
      });
      var prize = JSON.parse(JSON.stringify(_enums.prizeItem));
      prize.prizePic = this.mediaDomain + _enums.prizeItemPicMap[0];
      prize.awardName = prize.prizeType === 99 ? '谢谢参与' : "".concat(chineseNumberMaps[prizeLen + 1], "\u7B49\u5956");
      if (index === -1) {
        prizes.push(prize);
      } else {
        prizes.splice(index, 0, prize);
      }
    },
    modalPicTap: function modalPicTap(key) {
      var _this = this;
      if (_this.isDisabled) return;
      this.$modalUpload(function (img) {
        if (!img) return;
        _this.formData[key] = img[0].sattDir;
      }, false, 'content');
    },
    // 上一步
    handleSubmitUp: function handleSubmitUp() {
      this.currentTab = (Number(this.currentTab) - 1).toString();
    },
    // 下一步
    handleSubmitNest: function handleSubmitNest(name) {
      var _this8 = this;
      if (this.isDisabled) {
        this.currentTab = (Number(this.currentTab) + 1).toString();
        return;
      }
      this.$refs[name].validate(function (valid, obj) {
        if (valid) {
          _this8.currentTab = (Number(_this8.currentTab) + 1).toString();
        } else {
          for (var key in obj) {
            var msg = obj[key][0].message;
            return _this8.$message.warning(msg);
          }
        }
      });
    },
    //保存接口数据更新
    getFormData: function getFormData() {
      var data = _objectSpread(_objectSpread({}, this.formData), {}, {
        drawStartTime: this.formData.drawTime[0],
        drawEndTime: this.formData.drawTime[1],
        replyId: this.formData.replyIds.join(',')
      });
      if (!data.prizes.length) {
        this.$message.warning('请添加奖项');
        return false;
      } else {
        var activityType = data.activityType,
          activityStyle = data.activityStyle;
        if (activityType === 2) {
          if (data.winTime < data.drawEndTime) {
            this.$message.warning('开奖时间不得早于结束时间');
            return false;
          }
        }
        if ([4, 5].includes(activityStyle)) {
          // 九宫格抽奖，如果奖项数量不为8个，提示
          if (data.prizes.length !== this.maxPrizeLength) {
            this.$message.warning("\u62BD\u5956\u5956\u9879\u9700\u8BBE\u7F6E".concat(this.maxPrizeLength, "\u4E2A"));
            return false;
          }
        }
        for (var i = 0; i < data.prizes.length; i++) {
          var item = data.prizes[i];
          var res = this.checkPrize(item, activityType);
          if (!res) {
            return false;
          }
          item.sort = i;
        }
      }
      if (data.assistFlag === 2) {
        var taskTypeCounts = {};
        for (var _i = 0; _i < data.assistTasks.length; _i++) {
          var _item = data.assistTasks[_i];
          var taskType = _item.taskType;
          if (!taskTypeCounts[taskType]) {
            taskTypeCounts[taskType] = 1;
          } else if (taskType === 2) {
            this.$message.warning('仅能配置一个`分享好友参与`助力任务');
            return false;
          }
          var _res = this.checkTask(_item);
          if (!_res) {
            return false;
          }
          _item.sort = _i;
        }
      }
      if (data.joinType === 6) {
        data.dailyLimit = data.coinDrawTimes + data.videoDrawTimes;
      }
      if (this.operate === 'edit') {
        data.activityId = this.id;
      }
      data.prizeSaveRequest = data.prizes;
      return data;
    },
    checkPrize: function checkPrize(prizeItem, activityType) {
      if (!prizeItem.awardName) {
        this.$message.warning('请填写奖项名称');
        return false;
      }
      if (!prizeItem.prizeName) {
        this.$message.warning('请填写奖品名称');
        return false;
      }
      if (prizeItem.prizeType === 1) {
        if (prizeItem.doubleRewardSwitch && prizeItem.doubleRewardMultiple <= 0) {
          this.$message.warning('请输入奖励倍数');
          return false;
        }
      }
      if (prizeItem.prizeType === 3) {
        if (!prizeItem.redPacketPrice) {
          this.$message.warning('请输入红包金额');
          return false;
        }
      }
      if (prizeItem.prizeType === 4) {
        if (!prizeItem.productId) {
          this.$message.warning('请选择商城商品');
          return false;
        }
        if (!prizeItem.productIntegral) {
          this.$message.warning('请输入商品兑换积分');
          return false;
        }
      }
      if (![4, 5].includes(prizeItem.prizeType)) {
        if (!prizeItem.prizePic) {
          this.$message.warning('请选择奖品图片');
          return false;
        }
      }
      if (activityType !== 6) {
        if (!prizeItem.winProbability && prizeItem.winProbability !== 0) {
          this.$message.warning('请填写中奖概率');
          return false;
        }
      }
      return true;
    },
    checkTask: function checkTask(taskItem) {
      if (!taskItem.taskName) {
        this.$message.warning('请填写任务名称');
        return false;
      }
      if (!taskItem.taskType) {
        this.$message.warning('请选择参与条件');
        return false;
      }
      if (taskItem.taskType === 1) {
        if (!taskItem.advId) {
          this.$message.warning('请选择任务广告');
          return false;
        }
      }
      if (taskItem.taskType === 4) {
        if (!taskItem.appId) {
          this.$message.warning('请填写小程序appid');
          return false;
        }
        if (!taskItem.jumpUrl) {
          this.$message.warning('请填写跳转链接');
          return false;
        }
      }
      if (!taskItem.dailyLimit && taskItem.dailyLimit !== 0) {
        this.$message.warning('请填写每日任务上限次数');
        return false;
      }
      if (!taskItem.rewardTicket && taskItem.rewardTicket !== 0) {
        this.$message.warning('请填写赠送抽奖券数量');
        return false;
      }
      return true;
    },
    // 保存
    handleSubmit: function handleSubmit(name) {
      var _this9 = this;
      this.$refs[name].validate(function (valid, obj) {
        if (valid) {
          _this9.postData();
        } else {
          for (var key in obj) {
            var msg = obj[key][0].message;
            return _this9.$message.warning(msg);
          }
        }
      });
    },
    // 新增保存数据
    postData: function postData() {
      var _this10 = this;
      this.loadingBtn = true;
      var data = this.getFormData();
      if (!data) {
        this.loadingBtn = false;
        return;
      }
      var func = this.operate === 'edit' ? _lotteryAssistant.activityUpdateApi : _lotteryAssistant.activityCreateApi;
      func(data).then(function (res) {
        _this10.$message.success('保存成功');
        _this10.closeSelectedTag();
        _this10.loadingBtn = false;
      }).catch(function (res) {
        _this10.loadingBtn = false;
      });
    },
    isActive: function isActive(route) {
      return route.path === this.$route.path;
    },
    closeSelectedTag: function closeSelectedTag() {
      var _this11 = this;
      var route = this.$route;
      this.$store.dispatch('tagsView/delView', route).then(function () {
        if (_this11.isActive(route)) {
          _this11.closeTag(route);
          _this11.$router.push({
            path: _this11.backUrl
          });
        }
      });
    }
  })
};